import { HEALTHCARE_COURSE_FEE_DISTRIBUTION, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListHealthcareCourseFeeDistributions from "./List";

export const resources = {
  isMenu: false,
  name: SpecialistServicePath + HEALTHCARE_COURSE_FEE_DISTRIBUTION,
  title: "Разпределение на такси курсове за здравни грижи",
  list: <ListHealthcareCourseFeeDistributions />,
  permission: permissions.canPreviewHealthcareCourseFeeDistributions,
};
